<div class="flex-row connect-opa-footer-top">
  <div>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://opa.hhs.gov/grant-programs/title-x-service-grants/current-title-x-service-grantees"
      >Download Title X Directory</a
    >
  </div>
</div>
<div class="connect-opa-footer-bottom">
  <div class="oash-img">
    <img src="assets/oash-logo.svg" alt="OASH" />
  </div>
  <div class="sign-up">
    <form
      class="form-inline"
      accept-charset="UTF-8"
      action="https://public.govdelivery.com/accounts/USHHSOPA/subscriber/qualify?topic_id=USHHSOPA_2"
      method="get"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div class="email-sign-up-text">
        <mat-label for="email" class="signup-label">
          Sign Up for Email Updates
        </mat-label>
        <p>
          To sign up for updates please enter your contact information below
        </p>
      </div>
      <div class="email-signup-wrapper">
        <input
          aria-label="Sign up for email updates"
          type="email"
          name="email"
          id="email"
        />
        <span>
          <input class="signUpbottom" type="submit" value="Sign Up" />
        </span>
      </div>
    </form>
  </div>
</div>
